import React from "react";
import { Marquee } from "../../ui/marquee";

const Brands: React.FC = () => {
  return (
    <div className="w-full p-4 bg-white shadow-md rounded">
      <div className="w-full flex justify-center items-center">
        <h3 className="font-bold lg:text-lg xl:text-2xl lg:py-3">
          Brands Who Trust Us
        </h3>
      </div>
      <Marquee pauseOnHover className="[--duration:20s]">
        <div className="flex gap-16 px-10 w-full">
          <div className="flex justify-center items-center">
            <img src="/brands/brand-1.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-2.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-3.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-4.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-5.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-6.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-7.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-8.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-9.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-10.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-11.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-12.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-13.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-14.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-15.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-16.png" alt="" className="max-w-24" />
          </div>
          <div className="flex justify-center items-center">
            <img src="/brands/brand-17.png" alt="" className="max-w-24" />
          </div>
        </div>
      </Marquee>
    </div>
  );
};

export default Brands;
